module.exports = __webpack_public_path__ + "static/img/10.ba1ab1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/10.png
// module id = ptx7
// module chunks = 1